const CalendarGo = () => (
  <>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7 5a2.5 2.5 0 0 0-2.5 2.5V13a.5.5 0 0 0 1 0V9.5h13v8A1.5 1.5 0 0 1 17 19h-5.5a.5.5 0 0 0 0 1H17a2.5 2.5 0 0 0 2.5-2.5v-10A2.5 2.5 0 0 0 17 5h-1V3a.5.5 0 0 0-1 0v2H9V3a.5.5 0 0 0-1 0v2zm0 1a1.5 1.5 0 0 0-1.5 1.5v1h13v-1A1.5 1.5 0 0 0 17 6z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M8.979 19.498a.8.8 0 0 1-.053.296.8.8 0 0 1-.184.267l-2.681 2.681a.5.5 0 0 1-.344.15.47.47 0 0 1-.364-.15.5.5 0 0 1-.16-.353.5.5 0 0 1 .16-.354l2.04-2.04H2.5a.48.48 0 0 1-.356-.143.49.49 0 0 1-.144-.357q0-.212.144-.356a.49.49 0 0 1 .356-.143h4.892l-2.039-2.04a.5.5 0 0 1-.15-.344.47.47 0 0 1 .15-.363.5.5 0 0 1 .354-.16.5.5 0 0 1 .354.16l2.681 2.681a.8.8 0 0 1 .184.27.8.8 0 0 1 .053.298"
    />
  </>
)
export default CalendarGo
